import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_4 = { class: "form-check" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_7 = { class: "form-check" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_10 = { class: "form-check" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "input-group" }
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = { class: "input-group" }
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = { class: "f-w-700 pb-1" }
const _hoisted_22 = { class: "col-sm-6" }
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = { class: "mb-3" }

import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'productStock',
  setup(__props) {

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const stockData = productGroup.stock
        compState.autoStock = stockData.autoStock
        compState.returnsCanBeRestocked = stockData.returnsCanBeRestocked
        compState.stockSource = stockData.stockSource
        compState.stockLocation = stockData.stockLocation
        compState.stockLowWatermark = stockData.stockLowWatermark
        compState.stockHighWatermark = stockData.stockHighWatermark
        compState.saleToStockUnitRatio = stockData.saleToStockUnitRatio
        compState.currentStockLevel = stockData.currentStockLevel
        compState.saleUnit = stockData.saleUnit
        compState.stockUnit = stockData.stockUnit
    }
})

const compState = reactive({
    autoStock: false,
    returnsCanBeRestocked: false,
    stockSource: false,
    stockLocation: '',
    stockLowWatermark: 0,
    stockHighWatermark: 0,
    saleToStockUnitRatio: 0,
    currentStockLevel: 0,
    saleUnit: '',
    stockUnit: ''
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const stockData = productGroup.stock
        compState.autoStock = stockData.autoStock
        compState.returnsCanBeRestocked = stockData.returnsCanBeRestocked
        compState.stockSource = stockData.stockSource
        compState.stockLocation = stockData.stockLocation
        compState.stockLowWatermark = stockData.stockLowWatermark
        compState.stockHighWatermark = stockData.stockHighWatermark
        compState.saleToStockUnitRatio = stockData.saleToStockUnitRatio
        compState.currentStockLevel = stockData.currentStockLevel
        compState.saleUnit = stockData.saleUnit
        compState.stockUnit = stockData.stockUnit
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        stock: {
            autoStock: newVal.autoStock,
            returnsCanBeRestocked: newVal.returnsCanBeRestocked,
            stockSource: newVal.stockSource,
            stockLocation: newVal.stockLocation,
            stockLowWatermark: newVal.stockLowWatermark,
            stockHighWatermark: newVal.stockHighWatermark,
            saleToStockUnitRatio: newVal.saleToStockUnitRatio,
            currentStockLevel: newVal.currentStockLevel,
            saleUnit: newVal.saleUnit,
            stockUnit: newVal.stockUnit
        }
    })

}, { deep: true });

const stockLowWatermarkIncrement = () => {
    compState.stockLowWatermark++
}

const stockLowWatermarkDecrement = () => {
    if (compState.stockLowWatermark > 0) {
        compState.stockLowWatermark--
    }
}
const stockHighWatermarkIncrement = () => {
    compState.stockHighWatermark++
}

const stockHighWatermarkDecrement = () => {
    if (compState.stockHighWatermark > 0) {
        compState.stockHighWatermark--
    }
}
const saleToStockUnitRatioIncrement = () => {
    compState.saleToStockUnitRatio++
}

const saleToStockUnitRatioDecrement = () => {
    if (compState.saleToStockUnitRatio > 0) {
        compState.saleToStockUnitRatio--
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "Single-Item-Select",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.autoStock) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.autoStock]
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            class: "form-check-label",
            for: "Single-Item-Select"
          }, "Auto-stock", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "Show-on-Menu",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.returnsCanBeRestocked) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.returnsCanBeRestocked]
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            class: "form-check-label",
            for: "Show-on-Menu"
          }, "Returns can be restocked", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "Stock-Source",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.stockSource) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.stockSource]
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("label", {
            class: "form-check-label",
            for: "Stock-Source"
          }, "Stock Source", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[12] || (_cache[12] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Stock Location")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.stockLocation) = $event)),
          class: "form-control",
          type: "text",
          placeholder: "Name",
          maxlength: "32"
        }, null, 512), [
          [_vModelText, compState.stockLocation]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[13] || (_cache[13] = _createElementVNode("label", null, [
        _createElementVNode("h6", { class: "f-w-700" }, "Stock Low Watermark")
      ], -1)),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: "Threshold",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((compState.stockLowWatermark) = $event))
        }, null, 512), [
          [_vModelText, compState.stockLowWatermark]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: stockLowWatermarkDecrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: stockLowWatermarkIncrement
        }, "+")
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _cache[14] || (_cache[14] = _createElementVNode("label", null, [
        _createElementVNode("h6", { class: "f-w-700" }, "Stock High Watermark")
      ], -1)),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: "Threshold",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((compState.stockHighWatermark) = $event))
        }, null, 512), [
          [_vModelText, compState.stockHighWatermark]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: stockHighWatermarkDecrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: stockHighWatermarkIncrement
        }, "+")
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _cache[15] || (_cache[15] = _createElementVNode("label", null, [
        _createElementVNode("h6", { class: "f-w-700" }, "Sale to Stock Unit Ratio")
      ], -1)),
      _createElementVNode("div", _hoisted_18, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: "Threshold",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((compState.saleToStockUnitRatio) = $event))
        }, null, 512), [
          [_vModelText, compState.saleToStockUnitRatio]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: saleToStockUnitRatioDecrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: saleToStockUnitRatioIncrement
        }, "+")
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("h6", _hoisted_21, "Current Stock Level : " + _toDisplayString(compState.currentStockLevel), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _cache[17] || (_cache[17] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Sale Unit")
        ], -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((compState.saleUnit) = $event)),
          class: "form-select",
          "aria-label": "Sale Unit"
        }, _cache[16] || (_cache[16] = [
          _createStaticVNode("<option value=\"\" disabled data-v-73964996>Sale Unit</option><option value=\"Individually\" data-v-73964996>Individually</option><option value=\"Gram\" data-v-73964996>Gram (g)</option><option value=\"Kilogram\" data-v-73964996>Kilogram (kg)</option><option value=\"Milligram\" data-v-73964996>Milligram (mg)</option><option value=\"Ounce\" data-v-73964996>Ounce (oz)</option><option value=\"Pound\" data-v-73964996>Pound (lb)</option><option value=\"Carat\" data-v-73964996>Carat (ct)</option>", 8)
        ]), 512), [
          [_vModelSelect, compState.saleUnit]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _cache[19] || (_cache[19] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Stock Unit")
        ], -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((compState.stockUnit) = $event)),
          class: "form-select",
          "aria-label": "Stock Unit"
        }, _cache[18] || (_cache[18] = [
          _createStaticVNode("<option value=\"\" disabled data-v-73964996>Stock Unit</option><option value=\"Individually\" data-v-73964996>Individually</option><option value=\"Gram\" data-v-73964996>Gram (g)</option><option value=\"Kilogram\" data-v-73964996>Kilogram (kg)</option><option value=\"Milligram\" data-v-73964996>Milligram (mg)</option><option value=\"Ounce\" data-v-73964996>Ounce (oz)</option><option value=\"Pound\" data-v-73964996>Pound (lb)</option><option value=\"Carat\" data-v-73964996>Carat (ct)</option>", 8)
        ]), 512), [
          [_vModelSelect, compState.stockUnit]
        ])
      ])
    ])
  ]))
}
}

})